import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { Component } from 'react';
import { getBeginOfMonth, getDayOfWeek, getMonthIndex, getYear } from '../../utils/dates';
import language from '../../utils/language';
var Weekdays = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Weekdays, _Component);
  function Weekdays() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = Weekdays.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      formatShortWeekday = _this$props.formatShortWeekday,
      _this$props$locale = _this$props.locale,
      locale = _this$props$locale === void 0 ? 'en' : _this$props$locale,
      firstDayOfWeek = _this$props.firstDayOfWeek;
    var beginOfMonth = this.beginOfMonth,
      year = this.year,
      monthIndex = this.monthIndex;
    var weekdays = [];
    var weekdaysNameMap = new Map();
    var weekdayMinNameMap = new Map();
    if (locale && language[locale]) {
      var keys = language[locale].keys;
      var daysMinList = language[locale].daysMin;
      var daysList = language[locale].daysFull;
      for (var i = 0; i < keys.length; i++) {
        weekdaysNameMap.set(keys[i], daysList[i]);
        weekdayMinNameMap.set(keys[i], daysMinList[i]);
      }
    }
    for (var weekday = 0; weekday < 7; weekday += 1) {
      var weekdayDate = new Date(year, monthIndex, weekday - getDayOfWeek(beginOfMonth, firstDayOfWeek));
      var weekdayName = formatShortWeekday && formatShortWeekday(locale, weekdayDate).replace('.', '');
      weekdays.push( /*#__PURE__*/React.createElement("span", {
        className: "ap-single-weekday",
        key: weekday,
        "aria-label": weekdaysNameMap.get(weekdayName),
        tabIndex: -1,
        "data-abbr": weekdaysNameMap.get(weekdayName)
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": true
      }, weekdayMinNameMap.get(weekdayName))));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "ap-weekdays"
    }, weekdays);
  };
  _createClass(Weekdays, [{
    key: "beginOfMonth",
    get: function get() {
      var activeStartDate = this.props.activeStartDate;
      return getBeginOfMonth(activeStartDate);
    }
  }, {
    key: "year",
    get: function get() {
      var beginOfMonth = this.beginOfMonth;
      return getYear(beginOfMonth);
    }
  }, {
    key: "monthIndex",
    get: function get() {
      var beginOfMonth = this.beginOfMonth;
      return getMonthIndex(beginOfMonth);
    }
  }]);
  return Weekdays;
}(Component);
export { Weekdays as default };